import { apolloClientGenerator, DataCatalogApolloClient } from '@tableau/catalog-core';

/**
 * This is a global/shared/singleton instance of the Apollo client for Data Catalog that can be
 * passed into any Data Catalog components where needed.
 */
export const catalogApolloClient: DataCatalogApolloClient = apolloClientGenerator();
